<script>
	import { AppContext, AppData } from './Context.svelte';
	import TotalRaised from './TotalRaised.svelte';
	import StackedBar from './StackedBar.svelte';
	import CirclePack from './CirclePack.svelte';
	import { Chart } from '@vpap_svelte/charts';
	import ChartLegend from './ChartLegend.svelte';

	let ctx = AppContext.set(
		new AppData(
			'https://vpap-production.s3.amazonaws.com/media/visuals/custom/datasets/governor_inaugural_large_contributions_2026.json',
		),
	);
</script>

<div class="gfx-container">
	{#if ctx.data.length > 0}
		<div class="gfx-container">
			<div class="gfx-section">
				<h2>Total Large Donations through Dec. 31</h2>
				<div class="gfx-chart" style:height="300px">
					<Chart
						class="inaug-chart"
						style={{
							'padding-left': '4ch',
							'padding-top': '3px',
							'padding-bottom': '2rem',
						}}
					>
						<TotalRaised />
					</Chart>
				</div>
			</div>
			<div class="gfx-section">
				<h2>Percentage Raised by Donor Type</h2>
				<ChartLegend></ChartLegend>
				<div class="gfx-chart" style:height="{ctx.byGovernor.size * 4}rem">
					<Chart class="inaug-chart" style={{ 'padding-left': '5rem' }}>
						<StackedBar />
					</Chart>
				</div>
			</div>
			<div class="gfx-section">
				<h2>Spanberger's Large Donors through Dec. 31</h2>
				<ChartLegend></ChartLegend>
				<div class="gfx-chart" style:height="400px">
					<Chart class="inaug-chart">
						<CirclePack />
					</Chart>
				</div>
			</div>
		</div>
	{/if}
</div>

<style>
	.gfx-section {
		margin: 1.5rem 0;
	}

	.gfx-chart {
		width: 100%;
	}

	.gfx-chart :global(.inaug-chart) {
		width: 100%;
		height: 100%;
	}

	.gfx-chart :global(.inaug-chart) :global(.pointer-none) {
		pointer-events: none;
	}

	.gfx-chart :global(.inaug-chart) :global(.pointer-all) {
		pointer-events: all;
	}
</style>
